module.exports = __webpack_public_path__ + "img/no_msg.03262a6b.png";